import { Ng2StateDeclaration } from '@uirouter/angular';

export const legalTermsState: Ng2StateDeclaration = {
  name: 'legal-terms',
  url: '/legal-terms' + '/:document',
  params: {
    document: 'privacy-policy'
  },
  data: {
    ignoreStateAsTitle: true,
    mobileHeaderTitle: 'page-titles.legal-terms.title',
    bodyClass: (APP: string) => {
      if (APP !== 'public') {
        return 'app-white';
      }
    }
  },
  loadComponent: () => import('./containers/legal-terms.component').then(m => m.LegalTermsComponent)
};
